<template >
        <span class="bgrndinfo" :style="backgroundStyle">
<!--                 <div style="float: right; margin-top:23px;">
                <a href="/sample.html">
                <el-tooltip class="item" effect="dark" :content="$t('menu.samples')" placement="bottom" :hide-after="3000">
                <img src="../../static/images/muster.png" alt="StruViMan graphic"/></el-tooltip></a>
                </div> -->
    
                <div>
                <h2>StruViMan</h2>
                <h3>Structural Visualization of Manuscripts</h3>
                </div>
    
                <div>                  

                  <p>StruViMan ist ein frei verfügbares Tool, um einen optischen Überblick über die Struktur von Handschriften zu erhalten. Alte Kodizes sind komplexe Objekte, und die Verfügbarkeit von digitalen Bildern und/oder Metadaten reicht oft nicht aus, um die strukturellen Eigenschaften schnell zu erfassen. Dabei spielt die diachrone Dimension eine wichtige Rolle (mehrere Produktionsschichten, Rekonstruktion vergangener Strata). StruViMan kann die Struktur nach zwei verschiedenen Kriterien aufschlüsseln (z.B. Produktionseinheiten, Inhaltselemente).</p>

                  <p>Das Tool wurde an der Ludwig-Maximilians-Universität München in Zusammenhang des ERC-Projekts „Paratexts of the Bible (ParaTexBib)“ entwickelt. Es wurde durch einen Proof of Concept Grant finanziert (2017-2018, Grant No. 737621).</p>
    
                <p>Das Tool wird auf der Seite <a href="https://www.manuscripta-biblica.org" target="_blank">www.manuscripta-biblica.org</a> und auf der Seite <a href="https://pinakes.irht.cnrs.fr/" target="_blank">pinakes.irht.cnrs.fr/</a> eingesetzt. Es ist offen für weitere Einsatzmöglichkeiten.</p>
                
                <p>Zu Demonstrationszwecken findet sich eine Liste von Handschriften <a href="/sample.html"> hier</a>.</p>

                <p>Technische Informationen zur Benutzung finden sich unten bei „Information &amp; Hilfe“. Für weitergehende Erklärungen siehe den Artikel <a href="https://doi.org/10.1515/opth-2019-0009" target="_blank"> hier</a>.</p>
                
                </div>
              </span>
</template>

<script >

export default {
    name: 'VStartInfoEn',
    props: {
        backgroundStyle: {
            default: ''
        }
    }
}

</script>




// WEBPACK FOOTER //
// src/components/VStartInfoDe.vue